import { Component, Input, Output, EventEmitter } from '@angular/core';
import { VersionPreview } from '../_interfaces/version-preview.interface';

@Component({
  selector: 'app-version-preview',
  template: `
    <ion-item>
      <ion-label>
        <h2>{{ version.name }}</h2>
        <p>{{ 'groups.createdAt' | translate }}: {{ version.versionDate | date : 'dd/MM/yyyy' }}</p>
      </ion-label>
      <div slot="end">
        <ion-button fill="clear" mode="ios" color="danger"
          (click)="deleteVersion.emit( version.id )" >
          <ion-icon class="bp-delete" name="delete" ></ion-icon>
        </ion-button>
        <ion-button fill="clear" mode="ios" color="primary"
          (click)="manageVersion.emit( version )" >
          <ion-icon class="bp-setting" name="settingsCog" ></ion-icon>
        </ion-button>
        <ion-button fill="clear" mode="ios" color="primary"
          (click)="cloneVersion.emit( version.id )" >
          <ion-icon class="bp-clone" name="copy" ></ion-icon>
        </ion-button>
      </div>
    </ion-item>`
})
export class VersionPreviewComponent {

  @Input() version: VersionPreview;

  @Output() manageVersion: EventEmitter<VersionPreview> = new EventEmitter();
  @Output() deleteVersion: EventEmitter<number> = new EventEmitter();
  @Output() cloneVersion: EventEmitter<number> = new EventEmitter();

}
